import { useState, useEffect, useCallback } from 'react';
import {
  OfflineItinerariesService,
  OfflineItineraryEntry,
  OfflineSharedBy,
} from '@/services/offline-itineraries.service';

export const useOfflineItineraries = () => {
  const [items, setItems] = useState<OfflineItineraryEntry[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const all = await OfflineItinerariesService.list();
    all.sort(
      (a, b) =>
        new Date(b.downloadedAt).getTime() - new Date(a.downloadedAt).getTime()
    );
    setItems(all);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const download = useCallback(
    async (
      itinerary: any,
      sharedBy: OfflineSharedBy,
      onProgress?: (pct: number) => void
    ) => {
      await OfflineItinerariesService.downloadItinerary(
        itinerary,
        sharedBy,
        onProgress
      );
      await refresh();
    },
    [refresh]
  );

  const remove = useCallback(
    async (id: string) => {
      await OfflineItinerariesService.remove(id);
      await refresh();
    },
    [refresh]
  );

  const isDownloaded = useCallback(async (id: string) => {
    return OfflineItinerariesService.isDownloaded(id);
  }, []);

  return { items, loading, download, remove, isDownloaded, refresh };
};
